import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import AnimatedModal from "../../ReusableComponents/AnimatedModal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

const EditTowerStats = ({ isOpen, onRequestClose, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    totalInstalled: "",
    completed: "",
    inProgress: "",
    pending: "",
    currentStatus: "",
  });

  const [successModal, setSuccessModal] = useState(false);
  const [error, setError] = useState("");
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);

  const STATUS_OPTIONS = [
    { label: "In Progress", value: "inProgress" },
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" }
    
    
  ];

  useEffect(() => {
    if (isOpen) {
      console.log(initialData);
      setFormData({
        totalInstalled: initialData?.total_installed || "",
        completed: initialData?.completed_towers || "",
        inProgress: initialData?.in_progress_towers || "",
        pending: initialData?.pending_towers || "",
        currentStatus: initialData?.current_status || "pending",
      });
      setError("");
    }
  }, [isOpen, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const totalInstalled = Number(formData.totalInstalled) || 0;
    const completed = Number(formData.completed) || 0;
    const inProgress = Number(formData.inProgress) || 0;
    const pending = Number(formData.pending) || 0;

    if (
      totalInstalled < 0 ||
      completed < 0 ||
      inProgress < 0 ||
      pending < 0
    ) {
      return "Values cannot be negative.";
    }

    if (completed + inProgress + pending > totalInstalled) {
      return "Sum of Completed, In Progress, and Pending cannot exceed Total Installed.";
    }

    if (!formData.currentStatus) {
      return "Please select a current status.";
    }

    return "";
  };

  const handleSubmit = () => {
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    const payload = {
      totalInstalled: Number(formData.totalInstalled) || 0,
      completed: Number(formData.completed) || 0,
      inProgress: Number(formData.inProgress) || 0,
      pending: Number(formData.pending) || 0,
      currentStatus: formData.currentStatus,
    };

    onSubmit(payload);
    onRequestClose();

    setSuccessModal(true);
    setTimeout(() => setSuccessModal(false), 2500);
  };

  return (
    <>
      {/* ✅ Success Modal */}
      <AnimatedModal
        isOpen={successModal}
        onRequestClose={() => setSuccessModal(false)}
        width="fit-content"
        height="auto"
      >
        <div className="flex flex-col items-center justify-center text-center p-6">
          <CheckCircleIcon
            style={{ fontSize: 50, color: "#4CAF50", marginBottom: "10px" }}
          />
          <h2 className="text-lg font-semibold text-gray-800">
            Tower Stats Updated Successfully!
          </h2>
        </div>
      </AnimatedModal>

      {/* ✅ Edit Form Modal */}
      <AnimatedModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        width="35%"
        height="auto"
      >
        <div className="create-tower-container">
          <div className="create-tower-header">
            <p className="create-tower-title">Edit Tower Stats</p>
            <button onClick={onRequestClose} className="create-tower-close">
              ✕
            </button>
          </div>

          <div className="create-tower-form">
            {/* Total Installed */}
            <label className="create-tower-label">Total Towers Installed</label>
            <input
              type="number"
              name="totalInstalled"
              placeholder="Enter total installed"
              value={formData.totalInstalled}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* Completed */}
            <label className="create-tower-label">Completed Towers</label>
            <input
              type="number"
              name="completed"
              placeholder="Enter completed towers"
              value={formData.completed}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* In Progress */}
            <label className="create-tower-label">In Progress Towers</label>
            <input
              type="number"
              name="inProgress"
              placeholder="Enter in-progress towers"
              value={formData.inProgress}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* Pending */}
            <label className="create-tower-label">Pending Towers</label>
            <input
              type="number"
              name="pending"
              placeholder="Enter pending towers"
              value={formData.pending}
              onChange={handleChange}
              className="create-tower-input"
            />

            {/* Current Status Dropdown */}
            <label className="create-tower-label">Current Status</label>
            <Dropdown
              onSelect={(val) =>
                setFormData((prev) => ({ ...prev, currentStatus: val }))
              }
              onToggle={(isOpen) => setIsStatusDropdownOpen(isOpen)}
            >
              <Dropdown.Toggle
                variant="secondary"
                bsPrefix="custom-toggle"
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  marginBottom: "14px",
                  background: "#f2f2f2",
                  border: "2px solid #E5E7EB",
                  borderRadius: "5px",
                  fontSize: "12px",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  color: formData.currentStatus ? "#333" : "#89889E",
                  textAlign: "start",
                  outline: "none",
                  boxShadow: "none",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>
                  {formData.currentStatus
                    ? STATUS_OPTIONS.find(
                        (s) => s.value === formData.currentStatus
                      )?.label
                    : "Select Status"}
                </span>
                {isStatusDropdownOpen ? (
                  <KeyboardArrowUp fontSize="small" style={{ color: "#89889E" }} />
                ) : (
                  <KeyboardArrowDown
                    fontSize="small"
                    style={{ color: "#89889E" }}
                  />
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  width: "100%",
                  padding: 0,
                }}
              >
                {STATUS_OPTIONS.map((status) => (
                  <Dropdown.Item
                    key={status.value}
                    eventKey={status.value}
                    style={{
                      fontSize: "12px",
                      color: "#222",
                      padding: "8px 10px",
                    }}
                  >
                    {status.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Error Message */}
            {error && (
              <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                {error}
              </p>
            )}
          </div>

          <div className="create-tower-footer">
            <button onClick={handleSubmit} className="create-tower-submit">
              Update
            </button>
          </div>
        </div>
      </AnimatedModal>
    </>
  );
};

export default EditTowerStats;
